'use strict';
const angular = require('angular');

import {AbstractEventListenerProvider} from './AbstractEventListener';
import {FirebaseUtilProvider} from './AngularFire-util';
import {FirebaseConnectionServiceImport} from './FirebaseConnectionService';
import {FirebaseListenerProvider} from './FirebaseListener';
import {FirebaseObjectFactoryProvider} from './FirebaseObjectFactory';
import {FirebaseObjectListenerProvider} from './FirebaseObjectListener';
import {ObservableArrayFactoryProvider} from './ObservableArrayFactory';
import {$$ObservableArrayListenerProvider} from './ObservableArrayListener';

module.exports = angular
  .module('AngularFire.util', [
    'eventBus',
    'firebase',
    'persistent-cache',
  ])
  .provider('AbstractEventListener', AbstractEventListenerProvider)
  .provider('FirebaseUtil', FirebaseUtilProvider)
  .service('FirebaseConnectionService', FirebaseConnectionServiceImport)
  .provider('$$FirebaseListener', FirebaseListenerProvider)
  .provider('FirebaseObjectFactory', FirebaseObjectFactoryProvider)
  .provider('$$FirebaseObjectListener', FirebaseObjectListenerProvider)
  .provider('ObservableArrayFactory', ObservableArrayFactoryProvider)
  .provider('$$ObservableArrayListener', $$ObservableArrayListenerProvider)
;



// WEBPACK FOOTER //
// ./src/js/_libs/angular-fire-util/index.js